import api from './api'

export default {
    fetchEntry(params) {
      return api.get(`przedmiotanalizy/`, params)
                .then(response => response.data)
    },
    fetchSingleEntry(id) {
      return api.get(`przedmiotanalizy/${id}/`)
                .then(response => response.data)
    },
    postEntry(payload) {
      return api.post(`przedmiotanalizy/`, payload)
              },
    putEntry(payload, id) {
      return api.put(`przedmiotanalizy/${id}/`, payload)
              .then(response => response.data)
    },

    postBadanie(payload) {
      return api.post(`badanie/`, payload)
              },
    putBadanie(payload, id) {
      return api.put(`badanie/${id}/`, payload)
              },
    deleteBadanie(id) {
      return api.delete(`badanie/${id}/`)
              },

    postPunkt(payload) {
      return api.post(`punktkoncowy/`, payload)
              },
    putPunkt(payload, id) {
      return api.put(`punktkoncowy/${id}/`, payload)
              },
    deletePunkt(id) {
      return api.delete(`punktkoncowy/${id}/`)
              },
    postParametr(payload) {
      return api.post(`parametrstatystyczny/`, payload)
              },
    putParametr(payload, id) {
      return api.put(`parametrstatystyczny/${id}/`, payload)
              },
    deleteParametr(id) {
      return api.delete(`parametrstatystyczny/${id}/`)
              },

    postSubstancja(payload) {
      return api.post(`substancja/`, payload)
              },
    putSubstancja(payload, id) {
      return api.put(`substancja/${id}/`, payload)
              },
    deleteSubstancja(id) {
      return api.delete(`substancja/${id}/`)
              },
    postInstytucja(payload) {
      return api.post(`instytucja/`, payload)
              },
    putInstytucja(payload, id) {
      return api.put(`instytucja/${id}/`, payload)
              },
    deleteInstytucja(id) {
      return api.delete(`instytucja/${id}/`)
              },
    postWytyczna(payload) {
      return api.post(`wytycznaalter/`, payload)
              },
    putWytyczna(payload, id) {
      return api.put(`wytycznaalter/${id}/`, payload)
              },
    deleteWytyczna(id) {
      return api.delete(`wytycznaalter/${id}/`)
              },
    
            }